import api from "./Api";

class ControleEdicao {
  GetControleEdicao(payload) {
    return api.get("/v1/controleEdicao/" + payload).then((response) => {
      return response.data;
    });
  }

  PostControleEdicao(payload) {
    return api.post("/v1/controleEdicao/", payload).then((response) => {
      return response.data;
    });
  }

  PutControleEdicao(payload) {
    return api.put("/v1/controleEdicao/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteControleEdicao(payload) {
    return api.delete("/v1/controleEdicao/" + payload).then((response) => {
      return response.data;
    });
  }

  GetControleEdicaoOData(payload) {
    return api.get("/OData/ControleEdicao" + payload).then((response) => {
      return response.data;
    });
  }

  DeleteControleEdicaoIdEdicao(payload) {
    const { id_edicao, modulo } = payload;
    return api
      .delete(`/v1/controleEdicao/${id_edicao}/${modulo}`)
      .then((response) => {
        return response.data;
      });
  }
}

export default new ControleEdicao();
